exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal_title[data-v-a56c1bf8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-top:25px;padding-bottom:0}.circle[data-v-a56c1bf8]{padding:8px 10px;border-radius:100%;background-color:#fee2e2}.circle i[data-v-a56c1bf8]{font-size:30px}.text[data-v-a56c1bf8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:center;color:#111827;font-weight:600;font-size:24px}", ""]);

// exports
